import React from 'react';
import Projects from '../components/Projects';

const ProjectsPage = () => {
  return <Projects />;
};

export default ProjectsPage; 